import type { BoardPoint, BoardSize, FoxKifuRecordSummary, StoneColor } from '@wx-weiqi/contracts';

export function isFlyingKnifeRecord(record: Pick<FoxKifuRecordSummary, 'gameFamily'>): boolean {
  return record.gameFamily === 'FLYING_KNIFE';
}

/** Top of the vertical rail is the last move, bottom is the opening position. */
export function verticalProgressMove(
  clientY: number,
  top: number,
  height: number,
  totalMoves: number,
): number {
  if (height <= 16 || totalMoves <= 0) return 0;
  const fraction = 1 - (clientY - top - 8) / (height - 16);
  return Math.round(Math.max(0, Math.min(1, fraction)) * totalMoves);
}

/** Presentation only: stone occupancy is always supplied by the server. */
export function researchStoneLabels(
  moves: readonly BoardPoint[],
  stones: readonly (StoneColor | null)[],
  size: BoardSize,
): readonly { readonly point: BoardPoint; readonly label: string; readonly color: StoneColor }[] {
  const labels = new Map<
    string,
    { readonly point: BoardPoint; readonly label: string; readonly color: StoneColor }
  >();
  moves.forEach((point, index) => {
    const color = stones[point.y * size + point.x];
    if (color !== 'BLACK' && color !== 'WHITE') return;
    labels.set(`${point.x}:${point.y}`, { point, label: String(index + 1), color });
  });
  return [...labels.values()];
}

export function researchVariationPrefix(
  moves: readonly BoardPoint[],
  cursor: number,
): readonly BoardPoint[] {
  const boundedCursor = Math.max(0, Math.min(moves.length, Math.trunc(cursor)));
  return moves.slice(0, boundedCursor);
}

export function branchResearchVariation(
  moves: readonly BoardPoint[],
  cursor: number,
  point: BoardPoint,
): readonly BoardPoint[] {
  return [...researchVariationPrefix(moves, cursor), point];
}
